// apps/web/src/components/landing-v2/proofs/ShareProof.tsx
/** Theme 01 / Share your reading — preview tile + icon row.
 *  Reference: handoff .mm-share. */
export function ShareProof() {
  return (
    <div
      className="absolute inset-0 flex items-center justify-center p-[18px]"
      style={{
        background:
          'radial-gradient(ellipse at 50% 100%, color-mix(in oklab, var(--color-gold-light-legacy) 10%, transparent), transparent 65%)',
      }}
    >
      <div
        className="mx-auto flex w-[60%] flex-col items-center gap-1.5 rounded-xl border p-3.5 text-center"
        style={{
          background: 'linear-gradient(180deg, var(--color-deep-purple), var(--color-cosmic-black))',
          borderColor: 'color-mix(in oklab, var(--color-gold-light-legacy) 20%, transparent)',
          boxShadow: '0 20px 40px -15px rgba(0,0,0,0.6)' /* theme-audit: bespoke shadow */,
        }}
      >
        <div
          className="mx-auto aspect-[2/3] w-[55%] overflow-hidden rounded border border-hairline"
          style={{ background: 'var(--color-deep-purple)' }}
        >
          <img
            src="/cards/the-star.webp"
            alt=""
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="font-display italic text-text-primary" style={{ fontSize: '0.86rem' }}>
          The Star · Upright
        </div>
        <div className="text-[10px] text-text-muted">&ldquo;What can I trust?&rdquo;</div>
        <div className="mt-1 text-[9px] uppercase tracking-[0.22em] text-text-muted">
          The Cosmic Finder
        </div>
      </div>

      {/* Share icon strip */}
      <div className="pointer-events-none absolute bottom-3.5 left-3.5 right-3.5 flex justify-center gap-2">
        {['↗', '✎', '⌘', '★'].map((g) => (
          <span
            key={g}
            className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-hairline bg-hairline-faint text-[12px] text-text-secondary"
          >
            {g}
          </span>
        ))}
      </div>
    </div>
  )
}
